import { makeObservable, observable } from 'mobx';
import { MeasurementState } from './MeasurementState.js';

export class SectionState {
    api=null;
    panelId;
    section_name;
    measurements = [];
    constructor(section, panelId, api) {
	this.api=api;
        this.section_name = section.section_name;
        this.panelId = panelId;
        makeObservable(this, {
            measurements: observable,
        });

        for (let m of section.measurements) {
            this.measurements.push(
                new MeasurementState(
                    m,
                    panelId,
                    api
                ));
        }
    }
}
